import React, { useEffect } from 'react';

const PrintWrapper = ({ children, templateType }) => {
  useEffect(() => {
    // Force desktop viewport on mount
    const viewport = document.createElement('meta');
    viewport.setAttribute('name', 'viewport');
    viewport.setAttribute('content', 'width=1024');
    document.head.appendChild(viewport);

    return () => {
      document.head.removeChild(viewport);
    };
  }, []);

  useEffect(() => {
    const addPageBreaks = () => {
      const content = document.querySelector('.resume');
      if (!content) return;

      const sections = content.querySelectorAll('.resume__section');
      const viewportHeight = 1122; // A4 height in pixels at 96 DPI
      let currentHeight = 0;

      sections.forEach((section) => {
        const sectionHeight = section.getBoundingClientRect().height;
        
        if (currentHeight + sectionHeight > viewportHeight) {
          section.style.pageBreakBefore = 'always';
          currentHeight = sectionHeight;
        } else {
          currentHeight += sectionHeight;
        }
      });
    };

    window.addEventListener('beforeprint', addPageBreaks);
    return () => window.removeEventListener('beforeprint', addPageBreaks);
  }, []);

  return (
    <div className="print-wrapper">
      {children}
      <style jsx global>{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 15mm 20mm 25mm;
          }

          body {
            min-width: 210mm !important;
            max-width: 210mm !important;
            padding: 0 !important;
            margin: 0 !important;
          }

          .print-wrapper {
            width: 210mm !important;
            min-height: 297mm !important;
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
            transform: none !important;
          }

          .resume {
            width: 210mm !important;
            padding: 0 !important;
            margin: 0 !important;
            background: white !important;
            transform: none !important;
          }
          /* Template-specific adjustments */
          .template${templateType} {
            width: 210mm !important;
            min-height: 297mm !important;
            transform: none !important;
            max-width: none !important;
          }

          /* Force desktop layout */
          * {
            max-width: none !important;
            flex-shrink: 0 !important;
            transform: none !important;
          }

          /* Rest of your existing print styles... */
          .resume__section {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-bottom: 1.5rem !important;
          }

          .resume__columns {
            display: flex !important;
            flex-direction: row !important;
            padding: 0 !important;
            margin: 0 !important;
            gap: 2rem;
            width: 210mm !important;
          }

          /* Preserve colors and formatting */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }

        /* Force desktop layout in screen view */
        @media screen {
          .print-wrapper {
            width: 210mm !important;
            min-height: 297mm !important;
            margin: 0 auto !important;
            padding: 0 !important;
            background: white !important;
            transform: none !important;
          }

          /* Template-specific screen adjustments */
          .template${templateType} {
            width: 210mm !important;
            min-height: 297mm !important;
            transform: none !important;
            max-width: none !important;
          }
          .semibold {
          font-size:10px !important;
          }

          /* Force desktop layout */
          * {
            max-width: none !important;
            flex-shrink: 0 !important;
            transform: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PrintWrapper;